import React, { useEffect, useState } from "react";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import moment from "moment";
import Swal from "sweetalert2";

import $ from "jquery";

import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

function Quickassign() {

  const accesstoken = localStorage.getItem("token");
  const accessuserid = localStorage.getItem("id");
  const [selectAll, setSelectAll] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);

  const [tableData, setTableData] = useState([]);
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 1800,
        timerProgressBar: true,
        width: "300px",
    });

  // const Toast = Swal.mixin({

  //   toast: true,

  //   position: "top-end",

  //   showConfirmButton: false,

  //   timer: 1800,

  //   timerProgressBar: true,

  // });

  const handleSelectAll = () => {
    if (!selectAll) {

      const allIds = tableData.map(
        (item) => item.attendance_id
      );

      setSelectedRows(allIds);

    } else {

      setSelectedRows([]);

    }

    setSelectAll(!selectAll);

  };

  // =====================================
  // SINGLE CHECKBOX
  // =====================================

  const handleRowSelect = (id) => {

    let updatedRows = [...selectedRows];

    if (updatedRows.includes(id)) {

      updatedRows = updatedRows.filter(
        (item) => item !== id
      );

    } else {

      updatedRows.push(id);

    }

    setSelectedRows(updatedRows);

    setSelectAll(
      updatedRows.length === tableData.length
    );

  };

  // =====================================
  // HANDLE DATE CHANGE
  // =====================================

  const handleDateChange = (
    id,
    field,
    value
  ) => {

    const updatedData = tableData.map(
      (item) => {

        if (
          item.attendance_id === id
        ) {

          return {

            ...item,

            [field]: value,

          };

        }

        return item;

      }
    );

    setTableData(updatedData);

  };
    const handleApprove = (item) => {

        if (!item.shift_from) {
            Toast.fire({
                icon: "warning",
                title: "Please Select From Date",
            });
            return;
        }

        if (!item.shift_to) {
            Toast.fire({
                icon: "warning",
                title: "Please Select To Date",
            });
            return;
        }

        Swal.fire({
            title: "Approve Shift?",
            text: `Can you approve ${item.attendance_empname}'s shift?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545",
            confirmButtonText: "Approve",
            cancelButtonText: "Reject",
        }).then((result) => {

            // APPROVE
            if (result.isConfirmed) {

                axios.post(
                    baseurladdress + "approvequickshift",
                    {
                        attendance_id: item.attendance_id,
                        attendance_empid: item.attendance_empid,
                        attendance_empname: item.attendance_empname,
                        attendance_branchid: item.attendance_branchid,
                        attendance_branchname: item.attendance_branchname,
                        attendance_shiftid: item.attendance_shiftid,
                        attendance_shiftname: item.attendance_shiftname,
                        shift_from: item.shift_from,
                        shift_to: item.shift_to,
                        crtd_by: accessuserid,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                )
                    .then((res) => {

                        Toast.fire({
                            icon: "success",
                            title: "Shift Approved Successfully",
                        });

                        // Remove row immediately
                        setTableData((prevData) =>
                            prevData.filter(
                                (row) =>
                                    String(row.attendance_id) !==
                                    String(item.attendance_id)
                            )
                        );

                        setSelectedRows((prevRows) =>
                            prevRows.filter(
                                (id) =>
                                    String(id) !==
                                    String(item.attendance_id)
                            )
                        );

                        // Reload latest pending records
                        refreshTable();

                    })
                    .catch((error) => {

                        console.log(error);

                        Toast.fire({
                            icon: "error",
                            title: "Approval Failed",
                        });

                    });

            }

            // REJECT
            else if (result.dismiss === Swal.DismissReason.cancel) {

                axios.post(
                    baseurladdress + "rejectquickshift",
                    {
                        attendance_id: item.attendance_id,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                )
                    .then((res) => {

                        Toast.fire({
                            icon: "success",
                            title: "Shift Rejected Successfully",
                        });

                        // Remove row immediately
                        setTableData((prevData) =>
                            prevData.filter(
                                (row) =>
                                    String(row.attendance_id) !==
                                    String(item.attendance_id)
                            )
                        );

                        setSelectedRows((prevRows) =>
                            prevRows.filter(
                                (id) =>
                                    String(id) !==
                                    String(item.attendance_id)
                            )
                        );

                        // Reload latest pending records
                        refreshTable();

                    })
                    .catch((error) => {

                        console.log(error);

                        Toast.fire({
                            icon: "error",
                            title: "Rejection Failed",
                        });

                    });

            }

        });

    };
    const GetQuickShift = () => {

        axios.get(baseurladdress + "getquickshift", {
            headers: {
                Authorization: `Bearer ${accesstoken}`,
            },
        }).then((res) => {

            setTableData(res.data.data || []);

            setTimeout(() => {

                if (!$.fn.DataTable.isDataTable("#quickassign")) {

                    $("#quickassign").DataTable({
                        paging: true,
                        searching: true,
                        ordering: true,
                        info: true,
                        autoWidth: false,
                    });

                }

            }, 100);

        });

    };
   
    // const GetQuickShift = () => {

    //     axios.get(
    //         baseurladdress + "getquickshift",
    //         {
    //             headers: {
    //                 Authorization: `Bearer ${accesstoken}`,
    //             },
    //         }
    //     )
    //         .then((res) => {

    //             console.log("API Response:", res.data);

    //             const data = res.data.data || [];

    //             if ($.fn.DataTable.isDataTable("#quickassign")) {
    //                 $("#quickassign").DataTable().destroy();
    //             }

    //             setTableData(data);

    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });

    // };


  useEffect(() => {

    GetQuickShift();

  }, []);
    // useEffect(() => {

    //     if ($.fn.DataTable.isDataTable("#quickassign")) {
    //         $("#quickassign").DataTable().destroy();
    //     }

    //     if (tableData.length > 0) {
    //         setTimeout(() => {
    //             $("#quickassign").DataTable({
    //                 destroy: true,
    //                 paging: true,
    //                 searching: true,
    //                 info: true,
    //                 autoWidth: false,
    //                 ordering: true,
    //             });
    //         }, 100);
    //     }

    // }, [tableData]);

   //bulk approve
    const handleBulkApprove = async () => {

        const selectedData = tableData.filter((item) =>
            selectedRows.includes(item.attendance_id)
        );

        if (selectedData.length === 0) {
            Toast.fire({
                icon: "warning",
                title: "Please select at least one employee",
            });
            return;
        }

        // Validation
        for (const item of selectedData) {

            if (!item.shift_from) {
                Toast.fire({
                    icon: "warning",
                    title: `${item.attendance_empname} - Select From Date`,
                });
                return;
            }

            if (!item.shift_to) {
                Toast.fire({
                    icon: "warning",
                    title: `${item.attendance_empname} - Select To Date`,
                });
                return;
            }

        }

        const result = await Swal.fire({
            title: "Process Selected Shifts?",
            text: `${selectedData.length} employee(s) selected.`,
            icon: "question",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Approve",
            denyButtonText: "Reject",
            cancelButtonText: "Cancel",
        });

        try {

            // ======================
            // BULK APPROVE
            // ======================
            if (result.isConfirmed) {

                await Promise.all(
                    selectedData.map((item) =>
                        axios.post(
                            baseurladdress + "approvequickshift",
                            {
                                attendance_id: item.attendance_id,
                                attendance_empid: item.attendance_empid,
                                attendance_empname: item.attendance_empname,
                                attendance_branchid: item.attendance_branchid,
                                attendance_branchname: item.attendance_branchname,
                                attendance_shiftid: item.attendance_shiftid,
                                attendance_shiftname: item.attendance_shiftname,
                                shift_from: item.shift_from,
                                shift_to: item.shift_to,
                                crtd_by: accessuserid,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${accesstoken}`,
                                },
                            }
                        )
                    )
                );

                Toast.fire({
                    icon: "success",
                    title: "Selected shifts approved successfully",
                });

                // Reload pending records
               // GetQuickShift();
                await GetQuickShift();
                setSelectedRows([]);
                setSelectAll(false);
            }

            // ======================
            // BULK REJECT
            // ======================
            else if (result.isDenied) {

                await axios.post(
                    baseurladdress + "bulkrejectquickshift",
                    {
                        attendance_ids: selectedRows,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${accesstoken}`,
                        },
                    }
                );

                Toast.fire({
                    icon: "success",
                    title: "Selected shifts rejected successfully",
                });

                // Reload pending records
               // GetQuickShift();
                await GetQuickShift();
                setSelectedRows([]);
                setSelectAll(false);
            }

        } catch (error) {

            console.log(error);

            Toast.fire({
                icon: "error",
                title: "Operation failed",
            });

        }

    };
    
    const refreshTable = () => {

        if ($.fn.DataTable.isDataTable("#quickassign")) {

            $("#quickassign").DataTable().destroy();

        }

        setTimeout(() => {

            $("#quickassign").DataTable({
                destroy: true,
                paging: true,
                searching: true,
                info: true,
                ordering: true
            });

        }, 100);

    };
  return (

    <div>

      <Topnavbar />

      <Sidennav />

      <div className="content-wrap">

        <div className="main">

          <div className="container-fluid">

            <section id="main-content">

              <div className="card">

                {/* HEADER */}

                <div
                  className="card-header"
                  style={{

                    color: "black",

                    fontWeight: "600",

                    fontSize: "18px",

                  }}
                >
                  SHIFT APPROVAL LIST
                </div>

                {/* BODY */}

                <div className="card-body">

                  <div
                    style={{

                      width: "100%",

                      overflowX: "hidden",

                                      }}
                   
 
>

                  

                    <table
                      className="table table-bordered table-hover"
                      id="quickassign"
                      style={{

                        width: "100%",

                        tableLayout: "fixed",

                      }}
                    >

                      {/* TABLE HEAD */}

                      <thead
                        style={{

                          backgroundColor:
                            "#f8f9fa",

                          textAlign:
                            "center",

                        }}
                      >

                        <tr>

                          {/* CHECKBOX */}

                                                  <th style={{ width: "40px" }}>
                                                      <input
                                                          type="checkbox"
                                                          checked={selectAll}
                                                          onChange={handleSelectAll}
                                                          onClick={() => {
                                                              console.log("Select All Clicked");
                                                          }}
                                                          className="form-check-input"
                                                      />
                                                  </th>

                          <th
                            // style={{
                            //   width: "120px",
                            // }}
                          >
                            Staff Name
                          </th>

                          <th
                            // style={{
                            //   width: "150px",
                            // }}
                          >
                            Branch Name
                          </th>

                          <th
                            // style={{
                            //   width: "120px",
                            // }}
                          >
                            Shift Name
                          </th>

                          <th
                            // style={{
                            //   width: "140px",
                            // }}
                          >
                            Attendance
                          </th>

                          <th
                            // style={{
                            //   width: "140px",
                            // }}
                          >
                           Approval From
                          </th>

                          <th
                            // style={{
                            //   width: "140px",
                            // }}
                          >
                           Approved To
                          </th>

                          <th
                            // style={{
                            //   width: "70px",
                            // }}
                          >
                            Action
                          </th>

                        </tr>

                      </thead>

                      {/* TABLE BODY */}

                      <tbody>

                        {tableData.map((item) => (

                          <tr
                            key={
                              item.attendance_id
                            }
                          >

                            {/* ROW CHECKBOX */}

                            <td>

                              <input
                                type="checkbox"
                                className="form-check-input"
                                checked={selectedRows.includes(
                                  item.attendance_id
                                )}
                                onChange={() =>
                                  handleRowSelect(
                                    item.attendance_id
                                  )
                                }
                              />

                            </td>

                            {/* STAFF NAME */}

                            <td>
                              {
                                item.attendance_empname
                              }
                            </td>

                            {/* BRANCH */}

                            <td>
                              {
                                item.attendance_branchname
                              }
                            </td>

                            {/* SHIFT */}

                            <td>
                              {
                                item.attendance_shiftname
                              }
                            </td>

                            {/* ATTENDANCE */}

                            <td>

                              <div
                                style={{

                                  display:
                                    "flex",

                                  flexDirection:
                                    "column",

                                  lineHeight:
                                    "18px",

                                }}
                              >

                                {/* DATE */}

                                <span
                                  style={{

                                    fontWeight:
                                      "600",

                                    fontSize:
                                      "13px",

                                  }}
                                >

                                  {moment(
                                    item.attendance_date
                                  ).format(
                                    "DD-MM-YYYY"
                                  )}

                                </span>

                                {/* TIME */}

                                <span
                                  style={{

                                    fontSize:
                                      "12px",

                                    color:
                                      "#666",

                                  }}
                                >

                                  {moment(
                                    item.attendance_punching
                                  ).format(
                                    "hh:mm A"
                                  )}

                                  {" "}to{" "}

                                  {moment(
                                    item.attendance_punchout
                                  ).format(
                                    "hh:mm A"
                                  )}

                                </span>

                              </div>

                            </td>

                            {/* FROM DATE */}

                            <td>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                value={
                                  item.shift_from || ""
                                }
                                onChange={(e) =>
                                  handleDateChange(
                                    item.attendance_id,
                                    "shift_from",
                                    e.target.value
                                  )
                                }
                              />
                            </td>

                            {/* TO DATE */}

                            <td>

                              <input
                                type="date"
                                className="form-control form-control-sm"
                                value={
                                  item.shift_to || ""
                                }
                                onChange={(e) =>
                                  handleDateChange(
                                    item.attendance_id,
                                    "shift_to",
                                    e.target.value
                                  )
                                }
                              />

                            </td>

                            {/* ACTION */}
                                <td>
                                    <button className="btn btn-success btn-sm"
                                        style={{
                                            borderRadius: "50%",
                                            width: "32px",
                                            height: "32px",
                                            padding: "0px",
                                            fontSize: "16px",
                                            fontWeight: "bold",
                                        }}
                                        disabled={!selectedRows.includes(item.attendance_id)}
                                        onClick={() => handleApprove(item)}>
                                        ✓
                                    </button>
                                </td>
                           

                          </tr>

                        ))}

                      </tbody>

                    </table>

                  </div>

                </div>

              </div>

            </section>

          </div>

        </div>

      </div>
          {/* FLOATING APPROVE BUTTON */}
          <button
              className="btn btn-success"
              style={{
                  position: "fixed",
                  bottom: "20px",
                  right: "20px",
                  width: "60px",
                  height: "60px",
                  borderRadius: "50%",
                  zIndex: 999999,
                  fontSize: "24px",
                  fontWeight: "bold",
              }}
              onClick={handleBulkApprove}
          >
              ✓✓
          </button>
      {/* CUSTOM CSS */}
          <style>

              {`
        #quickassign th,
        #quickassign td {
          vertical-align: middle !important;
          text-align: center;
          white-space: normal !important;
          font-size: 13px;
        }

        #quickassign input[type="date"] {
          min-width: 120px;
        }

        .dataTables_wrapper .dataTables_filter {
          margin-bottom: 10px;
        }

        .dataTables_wrapper .dataTables_length {
          margin-bottom: 10px;
        }
      `}
          </style>
     

    </div>

  );

}

export default Quickassign;